import { ValueOpt } from "../form";

export type RadioValue = string | number;

export const RadioNA = "N/A";

export type RadioLabelValue = ValueOpt<RadioValue>;
